import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=29d00b08&scoped=true&"
import script from "./youtube-video.vue?vue&type=script&lang=js&"
export * from "./youtube-video.vue?vue&type=script&lang=js&"
import style0 from "./youtube-video.vue?vue&type=style&index=0&id=29d00b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d00b08",
  null
  
)

export default component.exports